"use strict";

var _knockout = require("knockout");

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//define a template source that simply treats the template name as its content
var templates = {},
    _data = {},
    engine = new _knockout2.default.nativeTemplateEngine(); //https://github.com/rniemeyer/SamplePresentation/blob/master/js/stringTemplateEngine.js


_knockout2.default.templateSources.stringTemplate = function (template) {
	this.templateName = template;
};

_knockout2.default.utils.extend(_knockout2.default.templateSources.stringTemplate.prototype, {
	data: function data(key, value) {
		_data[this.templateName] = _data[this.templateName] || {};

		if (arguments.length === 1) {
			return _data[this.templateName][key];
		}

		_data[this.templateName][key] = value;
	},
	text: function text(value) {
		if (arguments.length === 0) {
			return templates[this.templateName];
		}

		templates[this.templateName] = value;
	}
});

engine.makeTemplateSource = function (template, doc) {
	var elem;
	if (typeof template === "string") {
		elem = (doc || document).getElementById(template);

		if (elem) {
			return new _knockout2.default.templateSources.domElement(elem);
		}

		return new _knockout2.default.templateSources.stringTemplate(template);
	} else if (template && template.nodeType == 1 || template.nodeType == 8) {
		return new _knockout2.default.templateSources.anonymousTemplate(template);
	}
};

//make the templates accessible
_knockout2.default.templates = templates;

//make this new template engine our default engine
_knockout2.default.setTemplateEngine(engine);


//////////////////
// WEBPACK FOOTER
// ./node_modules/knockout-template-loader/lib/string-template-engine.js
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 12 13 14 15 16 17 18 19 20 21 22